import React from 'react'
import cn from 'classnames'
import { useTranslation } from 'react-i18next'

import styles from './styles.module.scss'

import PlaceIcon from '../../Icons/Place'
import SandClockIcon from '../../Icons/SandClock'
import GrownuSystemAvatar from 'components/Icons/GrownuSystemAvatar'

const PlaceRow = ({ place, isActive, onPress, onEnter, onLeave }) => {
  const { t } = useTranslation()

  return (
    <div
      key={place.id}
      className={cn(styles.placeItem, {[styles.active]: isActive})}
      onClick={onPress(place)}
      onMouseEnter={() => onEnter(place.id)}
      onMouseLeave={() => onLeave(place.id)}>
      <div className={styles.placeIcon} style={{ backgroundColor: place.color }}>
        {
          !place.coordinates ? <GrownuSystemAvatar /> : (place.type === 'place' ? <PlaceIcon color="#fff" /> : <SandClockIcon color="#fff" />)
        }
      </div>
      <div style={{flex: 1, overflow: 'hidden', gap: 4, display: 'flex', flexDirection: 'column'}}>
        <div className={styles.placeHeader}>
          <div className={styles.placeTitle}>{place.name}</div>
          <div style={{color: place.active_timer_count ? '#333945' : '#A5A8B1'}}>{place.active_timer_count}</div>
        </div>
        <div className={styles.placeFooter}>
          <div className={styles.placeAddress} data-tooltip-id="address" data-tooltip-content={place.address}>{place.address ? place.address : t('No address assigned')}</div>
          <div>{ t('clocked in') }</div>
        </div>
      </div>
    </div>
  )
}

export default PlaceRow
